<div id="table-admin">
  <div class="card">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <h5 *ngIf="casos.Comite == 0">MONITOR DE ALERTAS</h5>
            <h5 *ngIf="casos.Comite == 1">MONITOR DE ALERTAS CUMPLIMIENTO</h5>
            <h5 *ngIf="casos.Comite == 2">MONITOR DE ALERTAS COMITÉ</h5>
          </div>
        </div>
        <div class="card-block">
          <form novalidate (ngSubmit)="validarFormulario(formBuscarCasos)" #formBuscarCasos="ngForm">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <label>Nombre/Razón Social</label>
                  <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="casos.Nombre"
                    name="Nombre" />
                </div>
              </div>
              <div class="col-xs-12 col-md-3" style="display: none;">
                <div class="form-group">
                  <label>Segundo Nombre</label>
                  <input type="text" class="form-control" placeholder="Segundo Nombre" [(ngModel)]="casos.SNombre"
                    name="SNombre" />
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <label>Apellido Paterno</label>
                  <input type="text" class="form-control" placeholder="Apellido Paterno"
                    [(ngModel)]="casos.ApellidoPaterno" name="ApellidoPaterno" />
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <label>Apellido Materno</label>
                  <input type="text" class="form-control" placeholder="Apellido Materno"
                    [(ngModel)]="casos.ApellidoMaterno" name="ApellidoMaterno" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-2">
                <div class="form-group pt-3">
                  <label>Número de Caso</label>
                  <input type="text" class="form-control" placeholder="Numero de Caso" [(ngModel)]="casos.NoCaso"
                    name="NoCaso" inputmode="numeric" pattern="[0-9]*" onpaste="return false" oncopy="return false"
                    oncut="return false" ondrop="return false"
                    onkeydown="return (
                                        event.key >= '0' && event.key <= '9') || ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key);" />
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group pt-3">
                  <label>Tipo de Alerta</label>
                  <select class="form-control" [(ngModel)]="casos.AlertaId" name="AlertaId">
                    <option value="-1">Selecciona una Opción</option>
                    <option value="{{ alerta.alertaId }}" *ngFor="let alerta of alertas"
                      [title]="getTooltipTexto(alerta.alertaId)">
                      {{alerta.alerta }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-6" *ngIf="casos.Comite != 2">
                <h4 class="sub-title">
                  Desde - Hasta
                </h4>
                <div class="row">
                  <div class="col-6">
                    <input type="date" class="form-control" [(ngModel)]="casos.FechaInicial" name="FechaInicial" />

                  </div>
                  <div class="col-6">
                    <input type="date" class="form-control" [(ngModel)]="casos.FechaFinal" name="FechaFinal" />

                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-md-6">
                <h4 class="sub-title">
                  Dictaminado
                </h4>
                <div class="form-radio">
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" [value]="1" [(ngModel)]="casos.Dictaminado" name="Dictaminado"
                        [disabled]="casos.Reportado == 1" />
                      <i class="helper"></i>Sí
                    </label>
                  </div>
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" [value]="0" [(ngModel)]="casos.Dictaminado" name="Dictaminado"
                        [disabled]="casos.Reportado == 1" />
                      <i class="helper"></i>No
                    </label>
                  </div>
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" [value]="2" [(ngModel)]="casos.Dictaminado" name="Dictaminado"
                        [disabled]="casos.Reportado == 1" />
                      <i class="helper"></i>Ambos
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <h4 class="sub-title">
                  Reportado
                </h4>
                <div class="form-radio">
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" [value]="1" [(ngModel)]="casos.Reportado" name="Reportado"
                        (change)="validarDictamen(1)" />
                      <i class="helper"></i>Sí
                    </label>
                  </div>
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" [value]="0" [(ngModel)]="casos.Reportado" name="Reportado"
                        (change)="validarDictamen(0)" />
                      <i class="helper"></i>No
                    </label>
                  </div>
                  <div class="radio radio-inline">
                    <label>
                      <input type="radio" [value]="2" [(ngModel)]="casos.Reportado" name="Reportado"
                        (change)="validarDictamen(2)" />
                      <i class="helper"></i>Ambos
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right pt-3">
              <button *ngIf="casos.Comite == 0" type="button" [routerLink]="['/v2/agregarcaso']"
                class="btn btn-info col col-md-2 mr-5">
                Nuevo
              </button>
              <button type="submit" class="btn btn-info col col-md-2">
                Buscar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <lib-dynamic-table 
        [fromSearchButtom]="fromSearchButtom"
        [activeTotalRowsSection]="true"
        [downloadReport]="true" 
        [columns]="columns" 
        [data]="data" 
        [pageSize]="15" 
        [totalRows]="totalrows"
        (action)="onTableAction($event)" 
        (newbatch)="onNewBatch($event)" 
        (printReport)="onPrintReport()"
        [loadingTotalRows]="loadingTotalRows">
    </lib-dynamic-table>
  </div>
</div>


<div class="modal fade" id="modalCliente" tabindex="-1" role="dialog"
  style="z-index: 2000; overflow-y: auto !important;" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Buscar cliente</h4>
        <button type="button" class="close" (click)="cerrarCaso()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-buscar-persona [tipoPersona]="tipoPersona" [paraCaso]="true" [open]="esOpen">
        </app-buscar-persona>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default waves-effect " (click)="cerrarCaso()">
          Regresar
        </button>
        <button type="button" class="btn btn-primary waves-effect waves-light " *ngIf="alertaService.persona"
          (click)="transacciones()">
          Generar Caso
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalTransaccion" tabindex="-1" role="dialog"
  style="z-index: 2000; overflow-y: auto !important;" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Transacciones</h4>
        <button type="button" class="close" (click)="cerrarTransacciones()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-transacciones-cliente></app-transacciones-cliente>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default waves-effect " (click)="cerrarTransacciones()">
          Regresar
        </button>
        <button type="button" class="btn btn-primary waves-effect waves-light "
          *ngIf="alertaService.persona && alertaService.transaccionesRelacionar.length > 0" (click)="nuevo()">
          Relacionar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalCaso" tabindex="-1" role="dialog" style="z-index: 2000;  overflow-y: auto !important;"
  data-backdrop="static" data-keyboard="false">
  <form novalidate (ngSubmit)="validarFormularioCasos(formGuardarCaso)" #formGuardarCaso="ngForm">
    <div class="modal-dialog modal-lg modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Caso</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="page-body">
            <div class="card p-3">
              <div class="card-block accordion-block">
                <div id="accordion" role="tablist" aria-multiselectable="true">
                  <div class="accordion-panel">
                    <div class="accordion-heading bg-darkest-primary" role="tab" id="headingOne">
                      <h3 class="card-title accordion-title">
                        <a class="accordion-msg" data-toggle="collapse" data-parent="#accordion" href="#collapseOne"
                          aria-expanded="true" aria-controls="collapseOne">
                          Datos Generales
                          <div class="arrow-right">
                            <i class="ti-angle-double-down"></i>
                          </div>
                        </a>
                      </h3>
                    </div>
                    <div id="collapseOne" class="panel-collapse collapse show" role="tabpanel"
                      aria-labelledby="headingOne">
                      <div class="accordion-content accordion-desc">
                        <app-addcase-general-data></app-addcase-general-data>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-panel">
                    <div class="accordion-heading bg-darkest-primary" role="tab" id="headingTwo">
                      <h3 class="card-title accordion-title">
                        <a class="accordion-msg" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo"
                          aria-expanded="false" aria-controls="collapseTwo">
                          Transacciones
                          <div class="arrow-right">
                            <i class="ti-angle-double-down"></i>
                          </div>
                        </a>
                      </h3>
                    </div>
                    <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                      <div class="accordion-content accordion-desc">
                        <app-addcase-transactions></app-addcase-transactions>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default waves-effect " (click)="cerrarCCaso()">
            Regresar
          </button>
          <button type="submit" class="btn btn-primary waves-effect waves-light "
            *ngIf="alertaService.persona && !invalidCaso()">
            Guardar
          </button>
        </div>
      </div>
    </div>

  </form>
</div>
